<template>
  <footer class="footer">
    <div class="footer-top">
      <div class="footer-inner-top">
        <div class="grid grid-cols-10 w-full">
          <div class="col-span-10 md:col-span-4 lg:col-span-6 mb-8 md:mb-0">
            <kf-list
              :is-big="true"
              :items="listFirst"
            />
          </div>
          <div class="col-span-10 md:col-span-3 lg:col-span-2 mb-8 md:mb-0">
            <kf-list :items="listSecond" />
          </div>
          <div class="col-span-10 md:col-span-3 lg:col-span-2 mb-12 md:mb-0">
            <kf-list :items="listThird" />
          </div>
          <div class="col-span-10 flex flex-col items-center gap-2">
            <social-links :social-links="socialData" />
            <a
              v-if="privacy"
              class="meta-top-right is-alternative"
              :href="privacy.href"
            >
              {{ privacy.label }}
            </a>
          </div>
        </div>
      </div>
      <div class="svg-container">
        <kf-curve
          curve-alignment="left"
          curve-svg-color="gray"
        />
      </div>
    </div>
    <div class="footer-bottom">
      <div class="footer-inner-bottom">
        <div class="grid grid-cols-12 w-full">
          <div class="col-span-12 self-end md:self-start pb-8 md:pb-0">
            <div class="meta-top">
              <span
                v-if="copyright"
                class="meta-top-left"
              >
                {{ copyright }}
              </span>
            </div>
            <div class="meta-bottom">
              <div
                v-for="(logo, i) in footerLogos"
                :key="i"
              >
                <template v-if="logo.href">
                  <a
                    :href="logo.href"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      class="meta-bottom-image"
                      :src="logo.imageSrc"
                      :alt="logo.imageSrc"
                    >
                  </a>
                </template>
                <template v-else>
                  <img
                    class="meta-bottom-image"
                    :src="logo.imageSrc"
                    :alt="logo.imageSrc"
                  >
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import KfCurve from '@/components/base/curve/Curve.vue';
import KfList from '@/components/base/list/List.vue';
import SocialLinks from '@/components/SocialLinks.vue';

export default {
  name: 'KfFooter',
  components: {
    KfList,
    SocialLinks,
    KfCurve,
  },
  props: {
    listFirst: {
      type: Array,
      default: null,
    },
    listSecond: {
      type: Array,
      default: null,
    },
    listThird: {
      type: Array,
      default: null,
    },
    copyright: {
      type: String,
      default: null,
    },
    privacy: {
      type: Object,
      default: null,
    },
    socialData: {
      type: Array,
      default: null,
    },
    footerLogos: {
      type: Array,
      default: null,
    }
  },
};
</script>


<style lang="postcss">
.footer {
  @apply relative w-full bg-white pt-12;
  margin-top: auto;

  @screen md {
    @apply pt-20;
  }

  &-top {
    @apply relative w-full;
  }

  .svg-container {
    overflow: hidden;
    position: relative;
    margin-bottom: -1px; // Fixing the occasional gap between the curve and the footer
  }

  .curve-footer {
    position: absolute;
    top: 0;
    height: 100%;
    max-width: initial;
    width: 100vw;
  }

  &-inner-top {
    @apply relative w-full mx-auto flex container px-5 md:px-4;
  }

  &-bottom {
    @apply pt-4 bg-gray-50;

    @screen md {
      @apply pt-0;
    }
  }

  &-inner-bottom {
    @apply relative w-full mx-auto flex container px-5 md:px-4;

    .meta {
      &-top {
        @apply flex flex-col md:flex-row items-center justify-between mb-4 pt-4 text-sm;

        &-left {
          @apply block md:inline text-sm mb-4;

          @screen md {
            @apply mb-0;
          }
        }

        &-right {
          @apply mr-0 md:mr-4 block md:inline-block mb-4 md:mb-0 text-sm;
        }
      }

      &-bottom {
        @apply flex flex-col md:flex-row items-center justify-end text-sm;

        div:last-of-type {
          > .meta-bottom-image {
            @apply mb-0;
          }
        }

        @screen md {
          @apply pb-4;
        }

        &-image {
          @apply md:mr-4 mb-4 md:mb-0;
        }
      }
    }
  }
}
</style>
